import React, { useState } from 'react'
import style from "./Faqs.module.css";
import data from "../../json/Homepage/Faqs.json";

const Faqs = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleAnswer = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className={style.faqscontainer}>
            <div className="container">
                <div className={style.faqstextcontainer}>


                    <p className={style.faqstopic}>{data.topic}</p>
                    <h1 className={style.faqfullform}>{data.fullform}</h1>
                </div>

                <div className={style.qaList}>
                    {data.questions.map((item, index) => (
                        <div key={index} className={style.qaItem}>
                            <div className={style.questionRow}>
                                <p className={style.faqquestion}>{item.question}</p>

                                <button
                                    className={style.toggleBtn}
                                    onClick={() => toggleAnswer(index)}
                                >
                                    {openIndex === index ? "-" : "+"}
                                </button>
                            </div>

                            {openIndex === index && (
                                <p className={style.faqanswer}>{item.answer}</p>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Faqs;
